import type { Any } from '../constant/any';

export class MemoryDataCache<T> {
  private cache = new Map<string, typeof Any>();

  public get(key: string): T | undefined {
    return this.cache.get(key);
  }

  public set(key: string, value: T, timeout: number) {
    if (value) {
      this.cache.set(key, value);
      setTimeout(() => {
        this.cache.delete(key);
      }, timeout);
    }
  }
}
